import { useEffect } from 'react';

const useOutsideClick = (ref: React.RefObject<HTMLDetailsElement>) => {
  const handleClick = (e: MouseEvent) => {
    if (ref.current && !ref.current.contains(e.target as Node | null)) {
      ref.current.removeAttribute('open');
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  });
};

export default useOutsideClick;
